import { render, staticRenderFns } from "./TablaSiniestralidadProduccionPorSucursal.vue?vue&type=template&id=33599b9a"
import script from "./TablaSiniestralidadProduccionPorSucursal.vue?vue&type=script&lang=js"
export * from "./TablaSiniestralidadProduccionPorSucursal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports